import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import HonoreeCollage from '../components/home/HonoreeCollage';
import MissionSection from '../components/home/MissionSection';
import WhatWeDoSection from '../components/home/WhatWeDoSection';
import QuoteSection from '../components/home/QuoteSection';
import GallerySection from '../components/home/GallerySection';
import CTASection from '../components/home/CTASection';
import NewsletterSignup from '../components/common/NewsletterSignup';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Navbar />
      <HeroSection />
      <HonoreeCollage />
      <MissionSection />
      <WhatWeDoSection />
      <QuoteSection />
      <GallerySection />
      <NewsletterSignup />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
